// Language translations for each state
export const languageData = {
  'Karnataka': {
    code: 'kn',
    name: 'ಕನ್ನಡ',
    shortName: 'ಕನ್', // KN in Kannada script
    translations: {
      'Go Solar Today': 'ಇಂದು ಸೌರಶಕ್ತಿ ಪಡೆಯಿರಿ',
      'in': 'ನಲ್ಲಿ',
      'Go Solar Today in': 'ನಲ್ಲಿ ಇಂದು ಸೌರಶಕ್ತಿ ಪಡೆಯಿರಿ', // "[City] ನಲ್ಲಿ ಇಂದು ಸೌರಶಕ್ತಿ ಪಡೆಯಿರಿ"
      'Get your free solar consultation - residential or commercial': 'ನಿಮ್ಮ ಉಚಿತ ಸೌರಶಕ್ತಿ ಸಲಹೆ ಪಡೆಯಿರಿ - ವಾಸಯೋಗ್ಯ ಅಥವಾ ವಾಣಿಜ್ಯ',
      'Get a Free Quote for Rooftop Solar': 'ಗಾಳಿಮಾಳಿಗೆ ಸೌರಶಕ್ತಿಗೆ ಉಚಿತ ಉಲ್ಲೇಖ ಪಡೆಯಿರಿ',
      'Schedule a FREE consultation with us today!': 'ಇಂದು ನಮ್ಮೊಂದಿಗೆ ಉಚಿತ ಸಲಹೆ ನಿಗದಿಪಡಿಸಿ!',
      'Choose Your Project Type': 'ನಿಮ್ಮ ಯೋಜನೆಯ ಪ್ರಕಾರವನ್ನು ಆರಿಸಿ',
      'Residential': 'ವಾಸಯೋಗ್ಯ',
      'Housing Society': 'ವಸತಿ ಸಮಾಜ',
      'Commercial': 'ವಾಣಿಜ್ಯ',
      'Utility Scale': 'ಯುಟಿಲಿಟಿ ಪ್ರಮಾಣ',
      'Full Name': 'ಪೂರ್ಣ ಹೆಸರು',
      'Phone Number': 'ಫೋನ್ ಸಂಖ್ಯೆ',
      'Pin Code': 'ಪಿನ್ ಕೋಡ್',
      'City': 'ನಗರ',
      'Email': 'ಇಮೇಲ್',
      'Company Name': 'ಕಂಪನಿಯ ಹೆಸರು',
      'What is your average monthly electricity bill?': 'ನಿಮ್ಮ ಸರಾಸರಿ ಮಾಸಿಕ ವಿದ್ಯುತ್ ಬಿಲ್ ಎಷ್ಟು?',
      'Name of Housing Society': 'ವಸತಿ ಸಮಾಜದ ಹೆಸರು',
      'What is your designation in Housing Society?': 'ವಸತಿ ಸಮಾಜದಲ್ಲಿ ನಿಮ್ಮ ಹುದ್ದೆ ಏನು?',
      'Management committee member': 'ನಿರ್ವಹಣಾ ಸಮಿತಿ ಸದಸ್ಯ',
      'Resident': 'ನಿವಾಸಿ',
      'Builder': 'ನಿರ್ಮಾಣಕಾರ',
      'Facility Manager': 'ಸೌಲಭ್ಯ ನಿರ್ವಾಹಕ',
      'AGM approval status': 'AGM ಅನುಮೋದನೆಯ ಸ್ಥಿತಿ',
      'We already have AGM approval': 'ನಮಗೆ ಈಗಾಗಲೇ AGM ಅನುಮೋದನೆ ಇದೆ',
      'We don\'t have an AGM approval yet': 'ನಮಗೆ ಇನ್ನೂ AGM ಅನುಮೋದನೆ ಇಲ್ಲ',
      'We want help in preparing for our AGM': 'ನಮ್ಮ AGM ಗಾಗಿ ಸಿದ್ಧತೆ ಮಾಡಲು ನಮಗೆ ಸಹಾಯ ಬೇಕು',
      'Average Monthly Bill': 'ಸರಾಸರಿ ಮಾಸಿಕ ಬಿಲ್',
      'Preferred Time Slot': 'ಆದ್ಯತೆಯ ಸಮಯ',
      'Message (Optional)': 'ಸಂದೇಶ (ಐಚ್ಛಿಕ)',
      'Tell us about your solar requirements (residential/commercial)...': 'ನಿಮ್ಮ ಸೌರಶಕ್ತಿ ಅವಶ್ಯಕತೆಗಳ ಬಗ್ಗೆ ನಮಗೆ ತಿಳಿಸಿ (ವಾಸಯೋಗ್ಯ/ವಾಣಿಜ್ಯ)...',
      'Get Solar Quote': 'ಸೌರಶಕ್ತಿ ಉಲ್ಲೇಖ ಪಡೆಯಿರಿ',
      'Call Now': 'ಈಗ ಕರೆ ಮಾಡಿ',
      'Ready to Go Solar?': 'ಸೌರಶಕ್ತಿಗೆ ಸಿದ್ಧರಿದ್ದೀರಾ?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'ನಿರೀಕ್ಷಿಸಬೇಡಿ - ವೃತ್ತಿಪರ ಗಾಳಿಮಾಳಿಗೆ ಸೌರಶಕ್ತಿ ಸ್ಥಾಪನೆಗಾಗಿ ಇಂದು ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
      'Back to Home': 'ಮನೆಗೆ ಹಿಂದಿರುಗಿ',
      'Select your monthly bill': 'ನಿಮ್ಮ ಮಾಸಿಕ ಬಿಲ್ ಆರಿಸಿ',
      'Less than ₹1,500': '₹1,500 ಕ್ಕಿಂತ ಕಡಿಮೆ',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 ಕ್ಕಿಂತ ಹೆಚ್ಚು',
      'Select your average monthly bill': 'ನಿಮ್ಮ ಸರಾಸರಿ ಮಾಸಿಕ ಬಿಲ್ ಆರಿಸಿ',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 ಕ್ಕಿಂತ ಹೆಚ್ಚು',
      'Select a time slot': 'ಸಮಯ ಆರಿಸಿ',
      'Select your designation': 'ನಿಮ್ಮ ಹುದ್ದೆ ಆರಿಸಿ',
      'Select approval status': 'ಅನುಮೋದನೆಯ ಸ್ಥಿತಿ ಆರಿಸಿ',
      'Thank you! We will contact you soon.': 'ಧನ್ಯವಾದಗಳು! ನಾವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.',
      'Failed to send callback request, please try again.': 'ಕರೆಬ್ಯಾಕ್ ವಿನಂತಿಯನ್ನು ಕಳುಹಿಸಲು ವಿಫಲವಾಗಿದೆ, ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.'
    }
  },
  'Gujarat': {
    code: 'gu',
    name: 'ગુજરાતી',
    shortName: 'ગુ', // GU in Gujarati script
    translations: {
      'Go Solar Today': 'આજે સોલર જાઓ',
      'in': 'માં',
      'Go Solar Today in': 'માં આજે સોલર જાઓ', // "[City] માં આજે સોલર જાઓ"
      'Get your free solar consultation - residential or commercial': 'તમારી મફત સોલર સલાહ મેળવો - રહેઠાણ અથવા વ્યાપારીક',
      'Get a Free Quote for Rooftop Solar': 'રૂફટોપ સોલર માટે મફત કિંમત મેળવો',
      'Schedule a FREE consultation with us today!': 'આજે અમારી સાથે મફત સલાહ શેડ્યૂલ કરો!',
      'Choose Your Project Type': 'તમારા પ્રોજેક્ટનો પ્રકાર પસંદ કરો',
      'Residential': 'રહેઠાણ',
      'Housing Society': 'હાઉસિંગ સોસાયટી',
      'Commercial': 'વ્યાપારીક',
      'Utility Scale': 'યુટિલિટી સ્કેલ',
      'Full Name': 'પૂર્ણ નામ',
      'Phone Number': 'ફોન નંબર',
      'Pin Code': 'પિન કોડ',
      'City': 'શહેર',
      'Email': 'ઇમેઇલ',
      'Company Name': 'કંપનીનું નામ',
      'What is your average monthly electricity bill?': 'તમારો સરેરાશ માસિક વીજળી બિલ કેટલો છે?',
      'Name of Housing Society': 'હાઉસિંગ સોસાયટીનું નામ',
      'What is your designation in Housing Society?': 'હાઉસિંગ સોસાયટીમાં તમારું હોદ્દો શું છે?',
      'Management committee member': 'મેનેજમેન્ટ કમિટી સભ્ય',
      'Resident': 'નિવાસી',
      'Builder': 'બિલ્ડર',
      'Facility Manager': 'સુવિધા મેનેજર',
      'AGM approval status': 'AGM મંજૂરી સ્થિતિ',
      'We already have AGM approval': 'અમારી પાસે પહેલેથી જ AGM મંજૂરી છે',
      'We don\'t have an AGM approval yet': 'અમારી પાસે હજુ સુધી AGM મંજૂરી નથી',
      'We want help in preparing for our AGM': 'અમારા AGM માટે તૈયારીમાં અમને મદદ જોઈએ છે',
      'Average Monthly Bill': 'સરેરાશ માસિક બિલ',
      'Preferred Time Slot': 'પ્રિફર્ડ ટાઇમ સ્લોટ',
      'Message (Optional)': 'સંદેશ (વૈકલ્પિક)',
      'Tell us about your solar requirements (residential/commercial)...': 'તમારી સોલર જરૂરિયાતો વિશે અમને જણાવો (રહેઠાણ/વ્યાપારીક)...',
      'Get Solar Quote': 'સોલર કિંમત મેળવો',
      'Call Now': 'હવે કૉલ કરો',
      'Ready to Go Solar?': 'સોલર જવા માટે તૈયાર છો?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'રાહ જુઓ નહીં - વ્યાવસાયિક સોલર છત સ્થાપન માટે આજે અમારો સંપર્ક કરો',
      'Back to Home': 'ઘરે પાછા જાઓ',
      'Select your monthly bill': 'તમારો માસિક બિલ પસંદ કરો',
      'Less than ₹1,500': '₹1,500 કરતા ઓછું',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 કરતા વધુ',
      'Select your average monthly bill': 'તમારો સરેરાશ માસિક બિલ પસંદ કરો',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 કરતા વધુ',
      'Select a time slot': 'સમય સ્લોટ પસંદ કરો',
      'Select your designation': 'તમારું હોદ્દો પસંદ કરો',
      'Select approval status': 'મંજૂરી સ્થિતિ પસંદ કરો',
      'Thank you! We will contact you soon.': 'આભાર! અમે ટૂંક સમયમાં તમારો સંપર્ક કરીશું.',
      'Failed to send callback request, please try again.': 'કૉલબેક વિનંતી મોકલવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો.'
    }
  },
  'Maharashtra': {
    code: 'mr',
    name: 'मराठी',
    shortName: 'मर', // MR in Marathi script
    translations: {
      'Go Solar Today': 'आज सोलर करा',
      'in': 'मध्ये',
      'Go Solar Today in': 'मध्ये आज सोलर करा', // "[City] मध्ये आज सोलर करा"
      'Get your free solar consultation - residential or commercial': 'तुमची मोफत सोलर सल्ला मिळवा - निवासी किंवा व्यावसायिक',
      'Get a Free Quote for Rooftop Solar': 'छतावरील सोलरसाठी मोफत अंदाज मिळवा',
      'Schedule a FREE consultation with us today!': 'आज आमच्यासोबत मोफत सल्ला नियोजन करा!',
      'Choose Your Project Type': 'तुमचा प्रकल्प प्रकार निवडा',
      'Residential': 'निवासी',
      'Housing Society': 'हाउसिंग सोसायटी',
      'Commercial': 'व्यावसायिक',
      'Utility Scale': 'युटिलिटी स्केल',
      'Full Name': 'पूर्ण नाव',
      'Phone Number': 'फोन नंबर',
      'Pin Code': 'पिन कोड',
      'City': 'शहर',
      'Email': 'ईमेल',
      'Company Name': 'कंपनीचे नाव',
      'What is your average monthly electricity bill?': 'तुमचा सरासरी मासिक वीज बिल किती आहे?',
      'Name of Housing Society': 'हाउसिंग सोसायटीचे नाव',
      'What is your designation in Housing Society?': 'हाउसिंग सोसायटीमध्ये तुमचा पद काय आहे?',
      'Management committee member': 'व्यवस्थापन समिती सदस्य',
      'Resident': 'रहिवासी',
      'Builder': 'बिल्डर',
      'Facility Manager': 'सुविधा व्यवस्थापक',
      'AGM approval status': 'AGM मंजुरी स्थिती',
      'We already have AGM approval': 'आमच्याकडे आधीच AGM मंजुरी आहे',
      'We don\'t have an AGM approval yet': 'आमच्याकडे अजून AGM मंजुरी नाही',
      'We want help in preparing for our AGM': 'आमच्या AGM साठी तयारी करण्यात आम्हाला मदत हवी आहे',
      'Average Monthly Bill': 'सरासरी मासिक बिल',
      'Preferred Time Slot': 'पसंतीचा वेळ स्लॉट',
      'Message (Optional)': 'संदेश (पर्यायी)',
      'Tell us about your solar requirements (residential/commercial)...': 'तुमच्या सोलर आवश्यकतांबद्दल आम्हाला सांगा (निवासी/व्यावसायिक)...',
      'Get Solar Quote': 'सोलर अंदाज मिळवा',
      'Call Now': 'आता कॉल करा',
      'Ready to Go Solar?': 'सोलर करण्यासाठी तयार आहात?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'वाट पाहू नका - व्यावसायिक सोलर छत स्थापनेसाठी आज आमच्याशी संपर्क साधा',
      'Back to Home': 'मुख्यपृष्ठावर परत',
      'Select your monthly bill': 'तुमचा मासिक बिल निवडा',
      'Less than ₹1,500': '₹1,500 पेक्षा कमी',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 पेक्षा जास्त',
      'Select your average monthly bill': 'तुमचा सरासरी मासिक बिल निवडा',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 पेक्षा जास्त',
      'Select a time slot': 'वेळ निवडा',
      'Select your designation': 'तुमचा पद निवडा',
      'Select approval status': 'मंजुरी स्थिती निवडा',
      'Thank you! We will contact you soon.': 'धन्यवाद! आम्ही लवकरच तुमच्याशी संपर्क साधू.',
      'Failed to send callback request, please try again.': 'कॉलबॅक विनंती पाठविण्यात अयशस्वी, कृपया पुन्हा प्रयत्न करा.'
    }
  },
  'Tamil Nadu': {
    code: 'ta',
    name: 'தமிழ்',
    shortName: 'த', // TA in Tamil script
    translations: {
      'Go Solar Today': 'இன்று சூரிய சக்தியைப் பெறுங்கள்',
      'in': 'இல்',
      'Go Solar Today in': 'இல் இன்று சூரிய சக்தியைப் பெறுங்கள்', // "[City] இல் இன்று சூரிய சக்தியைப் பெறுங்கள்"
      'Get your free solar consultation - residential or commercial': 'உங்கள் இலவச சூரிய ஆற்றல் ஆலோசனையைப் பெறுங்கள் - குடியிருப்பு அல்லது வணிக',
      'Get a Free Quote for Rooftop Solar': 'கூரை சூரிய சக்திக்கு இலவச மதிப்பீட்டைப் பெறுங்கள்',
      'Schedule a FREE consultation with us today!': 'இன்று எங்களுடன் இலவச ஆலோசனையை திட்டமிடுங்கள்!',
      'Choose Your Project Type': 'உங்கள் திட்ட வகையைத் தேர்ந்தெடுக்கவும்',
      'Residential': 'குடியிருப்பு',
      'Housing Society': 'வீட்டுவசதி சங்கம்',
      'Commercial': 'வணிக',
      'Utility Scale': 'பயன்பாட்டு அளவு',
      'Full Name': 'முழு பெயர்',
      'Phone Number': 'தொலைபேசி எண்',
      'Pin Code': 'பின் குறியீடு',
      'City': 'நகரம்',
      'Email': 'மின்னஞ்சல்',
      'Company Name': 'நிறுவனத்தின் பெயர்',
      'What is your average monthly electricity bill?': 'உங்கள் சராசரி மாத மின்சார பில் எவ்வளவு?',
      'Name of Housing Society': 'வீட்டுவசதி சங்கத்தின் பெயர்',
      'What is your designation in Housing Society?': 'வீட்டுவசதி சங்கத்தில் உங்கள் பதவி என்ன?',
      'Management committee member': 'மேலாண்மை குழு உறுப்பினர்',
      'Resident': 'குடியிருப்பாளர்',
      'Builder': 'கட்டுமானம்',
      'Facility Manager': 'வசதி மேலாளர்',
      'AGM approval status': 'AGM ஒப்புதல் நிலை',
      'We already have AGM approval': 'எங்களிடம் ஏற்கனவே AGM ஒப்புதல் உள்ளது',
      'We don\'t have an AGM approval yet': 'எங்களிடம் இன்னும் AGM ஒப்புதல் இல்லை',
      'We want help in preparing for our AGM': 'எங்கள் AGM க்கு தயாரிக்க எங்களுக்கு உதவி தேவை',
      'Average Monthly Bill': 'சராசரி மாத பில்',
      'Preferred Time Slot': 'விரும்பிய நேர இடைவெளி',
      'Message (Optional)': 'செய்தி (விருப்பமானது)',
      'Tell us about your solar requirements (residential/commercial)...': 'உங்கள் சூரிய தேவைகளை எங்களுக்குத் தெரிவிக்கவும் (குடியிருப்பு/வணிக)...',
      'Get Solar Quote': 'சூரிய மதிப்பீட்டைப் பெறுங்கள்',
      'Call Now': 'இப்போது அழைக்கவும்',
      'Ready to Go Solar?': 'சூரிய சக்திக்கு தயாரா?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'காத்திருக்காதீர்கள் - தொழில்முறை சூரிய கூரை நிறுவல்களுக்கு இன்று எங்களைத் தொடர்பு கொள்ளுங்கள்',
      'Back to Home': 'வீட்டிற்கு திரும்ப',
      'Select your monthly bill': 'உங்கள் மாத பிலைத் தேர்ந்தெடுக்கவும்',
      'Less than ₹1,500': '₹1,500 க்கும் குறைவாக',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 க்கும் அதிகமாக',
      'Select your average monthly bill': 'உங்கள் சராசரி மாத பிலைத் தேர்ந்தெடுக்கவும்',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 க்கும் அதிகமாக',
      'Select a time slot': 'நேரத்தைத் தேர்ந்தெடுக்கவும்',
      'Select your designation': 'உங்கள் பதவியைத் தேர்ந்தெடுக்கவும்',
      'Select approval status': 'ஒப்புதல் நிலையைத் தேர்ந்தெடுக்கவும்',
      'Thank you! We will contact you soon.': 'நன்றி! நாங்கள் விரைவில் உங்களைத் தொடர்பு கொள்வோம்.',
      'Failed to send callback request, please try again.': 'கால்பேக் கோரிக்கையை அனுப்ப முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்.'
    }
  },
  'Andhra Pradesh': {
    code: 'te',
    name: 'తెలుగు',
    shortName: 'తె', // TE in Telugu script
    translations: {
      'Go Solar Today': 'ఈరోజు సౌరశక్తిని పొందండి',
      'in': 'లో',
      'Go Solar Today in': 'లో ఈరోజు సౌరశక్తిని పొందండి', // "[City] లో ఈరోజు సౌరశక్తిని పొందండి"
      'Get your free solar consultation - residential or commercial': 'మీ ఉచిత సౌరశక్తి సలహాను పొందండి - నివాస లేదా వాణిజ్య',
      'Get a Free Quote for Rooftop Solar': 'పైకప్పు సౌరశక్తికి ఉచిత అంచనాను పొందండి',
      'Schedule a FREE consultation with us today!': 'ఈరోజు మాతో ఉచిత సలహాను షెడ్యూల్ చేయండి!',
      'Choose Your Project Type': 'మీ ప్రాజెక్ట్ రకాన్ని ఎంచుకోండి',
      'Residential': 'నివాస',
      'Housing Society': 'హౌసింగ్ సొసైటీ',
      'Commercial': 'వాణిజ్య',
      'Utility Scale': 'యుటిలిటీ స్కేల్',
      'Full Name': 'పూర్తి పేరు',
      'Phone Number': 'ఫోన్ నంబర్',
      'Pin Code': 'పిన్ కోడ్',
      'City': 'నగరం',
      'Email': 'ఇమెయిల్',
      'Company Name': 'కంపెనీ పేరు',
      'What is your average monthly electricity bill?': 'మీ సగటు నెలవారీ విద్యుత్ బిల్లు ఎంత?',
      'Name of Housing Society': 'హౌసింగ్ సొసైటీ పేరు',
      'What is your designation in Housing Society?': 'హౌసింగ్ సొసైటీలో మీ హోదా ఏమిటి?',
      'Management committee member': 'నిర్వహణ కమిటీ సభ్యుడు',
      'Resident': 'నివాసి',
      'Builder': 'బిల్డర్',
      'Facility Manager': 'సౌకర్య నిర్వాహకుడు',
      'AGM approval status': 'AGM ఆమోద స్థితి',
      'We already have AGM approval': 'మాకు ఇప్పటికే AGM ఆమోదం ఉంది',
      'We don\'t have an AGM approval yet': 'మాకు ఇంకా AGM ఆమోదం లేదు',
      'We want help in preparing for our AGM': 'మా AGM కోసం సిద్ధం చేయడంలో మాకు సహాయం కావాలి',
      'Average Monthly Bill': 'సగటు నెలవారీ బిల్లు',
      'Preferred Time Slot': 'ఇష్టపడిన సమయం',
      'Message (Optional)': 'సందేశం (ఐచ్ఛికం)',
      'Tell us about your solar requirements (residential/commercial)...': 'మీ సౌర అవసరాల గురించి మాకు తెలియజేయండి (నివాస/వాణిజ్య)...',
      'Get Solar Quote': 'సౌర అంచనాను పొందండి',
      'Call Now': 'ఇప్పుడు కాల్ చేయండి',
      'Ready to Go Solar?': 'సౌరశక్తికి సిద్ధంగా ఉన్నారా?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'వేచి ఉండకండి - వృత్తిపరమైన సౌర పైకప్పు స్థాపనల కోసం ఈరోజు మాతో సంప్రదించండి',
      'Back to Home': 'హోమ్‌కు తిరిగి వెళ్ళండి',
      'Select your monthly bill': 'మీ నెలవారీ బిల్లును ఎంచుకోండి',
      'Less than ₹1,500': '₹1,500 కంటే తక్కువ',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 కంటే ఎక్కువ',
      'Select your average monthly bill': 'మీ సగటు నెలవారీ బిల్లును ఎంచుకోండి',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 కంటే ఎక్కువ',
      'Select a time slot': 'సమయాన్ని ఎంచుకోండి',
      'Select your designation': 'మీ హోదాను ఎంచుకోండి',
      'Select approval status': 'ఆమోద స్థితిని ఎంచుకోండి',
      'Thank you! We will contact you soon.': 'ధన్యవాదాలు! మేము త్వరలో మీతో సంప్రదిస్తాము.',
      'Failed to send callback request, please try again.': 'కాల్‌బ్యాక్ అభ్యర్థనను పంపడంలో విఫలమైంది, దయచేసి మళ్లీ ప్రయత్నించండి.'
    }
  },
  'Delhi': {
    code: 'hi',
    name: 'हिंदी',
    shortName: 'हिं', // HI in Hindi script
    translations: {
      'Go Solar Today': 'आज सोलर करें',
      'in': 'में',
      'Go Solar Today in': 'में आज सोलर करें', // "[City] में आज सोलर करें"
      'Get your free solar consultation - residential or commercial': 'अपनी मुफ्त सोलर सलाह प्राप्त करें - आवासीय या वाणिज्यिक',
      'Get a Free Quote for Rooftop Solar': 'छत सोलर के लिए मुफ्त उद्धरण प्राप्त करें',
      'Schedule a FREE consultation with us today!': 'आज हमारे साथ मुफ्त सलाह शेड्यूल करें!',
      'Choose Your Project Type': 'अपना प्रोजेक्ट प्रकार चुनें',
      'Residential': 'आवासीय',
      'Housing Society': 'हाउसिंग सोसाइटी',
      'Commercial': 'वाणिज्यिक',
      'Utility Scale': 'यूटिलिटी स्केल',
      'Full Name': 'पूरा नाम',
      'Phone Number': 'फोन नंबर',
      'Pin Code': 'पिन कोड',
      'City': 'शहर',
      'Email': 'ईमेल',
      'Company Name': 'कंपनी का नाम',
      'What is your average monthly electricity bill?': 'आपका औसत मासिक बिजली बिल कितना है?',
      'Name of Housing Society': 'हाउसिंग सोसाइटी का नाम',
      'What is your designation in Housing Society?': 'हाउसिंग सोसाइटी में आपका पद क्या है?',
      'Management committee member': 'प्रबंधन समिति सदस्य',
      'Resident': 'निवासी',
      'Builder': 'बिल्डर',
      'Facility Manager': 'सुविधा प्रबंधक',
      'AGM approval status': 'AGM अनुमोदन स्थिति',
      'We already have AGM approval': 'हमारे पास पहले से ही AGM अनुमोदन है',
      'We don\'t have an AGM approval yet': 'हमारे पास अभी तक AGM अनुमोदन नहीं है',
      'We want help in preparing for our AGM': 'हमें अपने AGM की तैयारी में मदद चाहिए',
      'Average Monthly Bill': 'औसत मासिक बिल',
      'Preferred Time Slot': 'पसंदीदा समय स्लॉट',
      'Message (Optional)': 'संदेश (वैकल्पिक)',
      'Tell us about your solar requirements (residential/commercial)...': 'अपनी सोलर आवश्यकताओं के बारे में हमें बताएं (आवासीय/वाणिज्यिक)...',
      'Get Solar Quote': 'सोलर उद्धरण प्राप्त करें',
      'Call Now': 'अभी कॉल करें',
      'Ready to Go Solar?': 'सोलर करने के लिए तैयार हैं?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'इंतजार न करें - पेशेवर सोलर छत स्थापना के लिए आज हमसे संपर्क करें',
      'Back to Home': 'होम पर वापस जाएं',
      'Select your monthly bill': 'अपना मासिक बिल चुनें',
      'Less than ₹1,500': '₹1,500 से कम',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 से अधिक',
      'Select your average monthly bill': 'अपना औसत मासिक बिल चुनें',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 से अधिक',
      'Select a time slot': 'समय चुनें',
      'Select your designation': 'अपना पद चुनें',
      'Select approval status': 'अनुमोदन स्थिति चुनें',
      'Thank you! We will contact you soon.': 'धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे.',
      'Failed to send callback request, please try again.': 'कॉलबैक अनुरोध भेजने में विफल, कृपया पुनः प्रयास करें.'
    }
  },
  'West Bengal': {
    code: 'bn',
    name: 'বাংলা',
    shortName: 'বা', // BN in Bengali script
    translations: {
      'Go Solar Today': 'আজ সৌরশক্তি পান',
      'in': 'এ',
      'Go Solar Today in': 'এ আজ সৌরশক্তি পান', // "[City] এ আজ সৌরশক্তি পান"
      'Get your free solar consultation - residential or commercial': 'আপনার বিনামূল্যে সৌরশক্তি পরামর্শ পান - আবাসিক বা বাণিজ্যিক',
      'Get a Free Quote for Rooftop Solar': 'ছাদ সৌরশক্তির জন্য বিনামূল্যে উদ্ধৃতি পান',
      'Schedule a FREE consultation with us today!': 'আজ আমাদের সাথে বিনামূল্যে পরামর্শ নির্ধারণ করুন!',
      'Choose Your Project Type': 'আপনার প্রকল্পের ধরন বেছে নিন',
      'Residential': 'আবাসিক',
      'Housing Society': 'হাউজিং সোসাইটি',
      'Commercial': 'বাণিজ্যিক',
      'Utility Scale': 'ইউটিলিটি স্কেল',
      'Full Name': 'পূর্ণ নাম',
      'Phone Number': 'ফোন নম্বর',
      'Pin Code': 'পিন কোড',
      'City': 'শহর',
      'Email': 'ইমেইল',
      'Company Name': 'কোম্পানির নাম',
      'What is your average monthly electricity bill?': 'আপনার গড় মাসিক বিদ্যুৎ বিল কত?',
      'Name of Housing Society': 'হাউজিং সোসাইটির নাম',
      'What is your designation in Housing Society?': 'হাউজিং সোসাইটিতে আপনার পদবী কী?',
      'Management committee member': 'ব্যবস্থাপনা কমিটি সদস্য',
      'Resident': 'বাসিন্দা',
      'Builder': 'বিল্ডার',
      'Facility Manager': 'সুবিধা ব্যবস্থাপক',
      'AGM approval status': 'AGM অনুমোদন অবস্থা',
      'We already have AGM approval': 'আমাদের ইতিমধ্যে AGM অনুমোদন আছে',
      'We don\'t have an AGM approval yet': 'আমাদের এখনও AGM অনুমোদন নেই',
      'We want help in preparing for our AGM': 'আমাদের AGM এর জন্য প্রস্তুতিতে আমাদের সাহায্য দরকার',
      'Average Monthly Bill': 'গড় মাসিক বিল',
      'Preferred Time Slot': 'পছন্দের সময় স্লট',
      'Message (Optional)': 'বার্তা (ঐচ্ছিক)',
      'Tell us about your solar requirements (residential/commercial)...': 'আপনার সৌর প্রয়োজনীয়তা সম্পর্কে আমাদের জানান (আবাসিক/বাণিজ্যিক)...',
      'Get Solar Quote': 'সৌর উদ্ধৃতি পান',
      'Call Now': 'এখন কল করুন',
      'Ready to Go Solar?': 'সৌরশক্তিতে যেতে প্রস্তুত?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'অপেক্ষা করবেন না - পেশাদার সৌর ছাদ ইনস্টলেশনের জন্য আজ আমাদের সাথে যোগাযোগ করুন',
      'Back to Home': 'হোমে ফিরে যান',
      'Select your monthly bill': 'আপনার মাসিক বিল নির্বাচন করুন',
      'Less than ₹1,500': '₹1,500 এর কম',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 এর বেশি',
      'Select your average monthly bill': 'আপনার গড় মাসিক বিল নির্বাচন করুন',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 এর বেশি',
      'Select a time slot': 'সময় নির্বাচন করুন',
      'Select your designation': 'আপনার পদবী নির্বাচন করুন',
      'Select approval status': 'অনুমোদন অবস্থা নির্বাচন করুন',
      'Thank you! We will contact you soon.': 'ধন্যবাদ! আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব.',
      'Failed to send callback request, please try again.': 'কলব্যাক অনুরোধ পাঠাতে ব্যর্থ, অনুগ্রহ করে আবার চেষ্টা করুন.'
    }
  },
  'Telangana': {
    code: 'te',
    name: 'తెలుగు',
    shortName: 'తె', // TE in Telugu script
    translations: {
      'Go Solar Today': 'ఈరోజు సౌరశక్తిని పొందండి',
      'in': 'లో',
      'Go Solar Today in': 'లో ఈరోజు సౌరశక్తిని పొందండి', // "[City] లో ఈరోజు సౌరశక్తిని పొందండి"
      'Get your free solar consultation - residential or commercial': 'మీ ఉచిత సౌరశక్తి సలహాను పొందండి - నివాస లేదా వాణిజ్య',
      'Get a Free Quote for Rooftop Solar': 'పైకప్పు సౌరశక్తికి ఉచిత అంచనాను పొందండి',
      'Schedule a FREE consultation with us today!': 'ఈరోజు మాతో ఉచిత సలహాను షెడ్యూల్ చేయండి!',
      'Choose Your Project Type': 'మీ ప్రాజెక్ట్ రకాన్ని ఎంచుకోండి',
      'Residential': 'నివాస',
      'Housing Society': 'హౌసింగ్ సొసైటీ',
      'Commercial': 'వాణిజ్య',
      'Utility Scale': 'యుటిలిటీ స్కేల్',
      'Full Name': 'పూర్తి పేరు',
      'Phone Number': 'ఫోన్ నంబర్',
      'Pin Code': 'పిన్ కోడ్',
      'City': 'నగరం',
      'Email': 'ఇమెయిల్',
      'Company Name': 'కంపెనీ పేరు',
      'What is your average monthly electricity bill?': 'మీ సగటు నెలవారీ విద్యుత్ బిల్లు ఎంత?',
      'Name of Housing Society': 'హౌసింగ్ సొసైటీ పేరు',
      'What is your designation in Housing Society?': 'హౌసింగ్ సొసైటీలో మీ హోదా ఏమిటి?',
      'Management committee member': 'నిర్వహణ కమిటీ సభ్యుడు',
      'Resident': 'నివాసి',
      'Builder': 'బిల్డర్',
      'Facility Manager': 'సౌకర్య నిర్వాహకుడు',
      'AGM approval status': 'AGM ఆమోద స్థితి',
      'We already have AGM approval': 'మాకు ఇప్పటికే AGM ఆమోదం ఉంది',
      'We don\'t have an AGM approval yet': 'మాకు ఇంకా AGM ఆమోదం లేదు',
      'We want help in preparing for our AGM': 'మా AGM కోసం సిద్ధం చేయడంలో మాకు సహాయం కావాలి',
      'Average Monthly Bill': 'సగటు నెలవారీ బిల్లు',
      'Preferred Time Slot': 'ఇష్టపడిన సమయం',
      'Message (Optional)': 'సందేశం (ఐచ్ఛికం)',
      'Tell us about your solar requirements (residential/commercial)...': 'మీ సౌర అవసరాల గురించి మాకు తెలియజేయండి (నివాస/వాణిజ్య)...',
      'Get Solar Quote': 'సౌర అంచనాను పొందండి',
      'Call Now': 'ఇప్పుడు కాల్ చేయండి',
      'Ready to Go Solar?': 'సౌరశక్తికి సిద్ధంగా ఉన్నారా?',
      'Don\'t wait - contact us today for professional solar rooftop installations': 'వేచి ఉండకండి - వృత్తిపరమైన సౌర పైకప్పు స్థాపనల కోసం ఈరోజు మాతో సంప్రదించండి',
      'Back to Home': 'హోమ్‌కు తిరిగి వెళ్ళండి',
      'Select your monthly bill': 'మీ నెలవారీ బిల్లును ఎంచుకోండి',
      'Less than ₹1,500': '₹1,500 కంటే తక్కువ',
      '₹1,500 - ₹2,500': '₹1,500 - ₹2,500',
      '₹2,500 - ₹4,000': '₹2,500 - ₹4,000',
      '₹4,000 - ₹8,000': '₹4,000 - ₹8,000',
      'More than ₹8,000': '₹8,000 కంటే ఎక్కువ',
      'Select your average monthly bill': 'మీ సగటు నెలవారీ బిల్లును ఎంచుకోండి',
      '₹0 - ₹50,000': '₹0 - ₹50,000',
      '₹50,000 - ₹2,00,000': '₹50,000 - ₹2,00,000',
      'More than ₹2,00,000': '₹2,00,000 కంటే ఎక్కువ',
      'Select a time slot': 'సమయాన్ని ఎంచుకోండి',
      'Select your designation': 'మీ హోదాను ఎంచుకోండి',
      'Select approval status': 'ఆమోద స్థితిని ఎంచుకోండి',
      'Thank you! We will contact you soon.': 'ధన్యవాదాలు! మేము త్వరలో మీతో సంప్రదిస్తాము.',
      'Failed to send callback request, please try again.': 'కాల్‌బ్యాక్ అభ్యర్థనను పంపడంలో విఫలమైంది, దయచేసి మళ్లీ ప్రయత్నించండి.'
    }
  }
};

// Get language data for a state
export const getLanguageForState = (stateName) => {
  return languageData[stateName] || null;
};
